<template>

    <article id="signin">

        <h1>Log ind</h1>

        <form @submit.prevent="onSubmit">
            <fieldset>
                <label for="email">
                    Email
                    <form-error :content="non_field_errors" />
                </label>
                <input 
                    type="text"
                    id="email"
                    v-model="email"
                    ref="email"
                    required
                    minlength="3"
                    pattern="[^\s]+"
                    title="Angiv en email eller et brugernavn">
            </fieldset>
            <fieldset>
                <label for="password">
                    Kodeord
                    <form-error :content="password_errors" />
                </label>
                <input type="password"
                       id="password"
                       v-model="password"
                       required>
            </fieldset>
            <fieldset>
                <input type="submit" value="Log ind">
            </fieldset>
        </form>

        <router-link to="/password-reset">Glemt dit kodeord?</router-link>
    
    </article>

</template>

<script>

    import formError from '../forms/Error.vue'

    export default {
        components: {
            formError
        },
        data () {
            return {
                email: '',
                password: '',
                non_field_errors: null,
                password_errors: null
            }
        },
        methods: {
            onSubmit () {
                this.$store.dispatch('login', {
                    username: this.email, 
                    password: this.password
                })
                .then(res => {
                    this.non_field_errors = null
                    this.password_errors = null
                    if (res.non_field_errors) {
                        this.non_field_errors = res.non_field_errors
                    }
                    if (res.password) {
                        this.password_errors = res.password
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        created: function() {
            if (this.$route.query.action === 'account_activate') {
                this.$store.dispatch('confirmCreateUser', { 
                    uid: this.$route.query.uid, 
                    token: this.$route.query.token 
                })
            }
        },
        mounted: function() {
            this.$refs.email.focus()
        }
    }

</script>

<style lang="scss">

    #signin {
        padding: 1rem;
        max-width: 30rem;

        .actions {
            margin: 0 0 1rem;
            padding: 0;
            border: none;

            .btn {
                margin: 0;
            }
        }
    }

</style>